import { render, staticRenderFns } from "./RowV1.vue?vue&type=template&id=c40ef3ec&"
import script from "./RowV1.vue?vue&type=script&lang=js&"
export * from "./RowV1.vue?vue&type=script&lang=js&"
import style0 from "./RowV1.vue?vue&type=style&index=0&id=c40ef3ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports